import history from './history';

const restoringPaths = new Set();

export function beginRestore(pathname) {
  if (pathname) restoringPaths.add(pathname);
}

export function endRestore(pathname) {
  if (pathname) restoringPaths.delete(pathname);
}

export function isRestoreActive(pathname = history.location.pathname) {
  return restoringPaths.has(pathname);
}
